import { computed, inject, Injectable, Signal, signal, WritableSignal } from '@angular/core';
import { FirebaseService } from '@core/services/firebase/firebase.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private firebaseAuth = inject(FirebaseService);
  private _token: Signal<string | null> = this.firebaseAuth.userToken;
  private _userRole: WritableSignal<string | undefined> = signal<string | undefined>(undefined);
  private _userPermissions: WritableSignal<string[]> = signal<string[]>([] as string[]);
  private clientId: Signal<string | null> = this.firebaseAuth.client_id;
  public readonly token: Signal<string | null> = computed(() => this._token());
  public readonly client_id: Signal<string | null> = computed(() => this.clientId());

  hasAccess(permissions: string[], mustHaveAll = false): boolean {
    if (!permissions?.length) {
      return true;
    }

    const userPerms: string[] = this._userPermissions();
    if (!userPerms?.length) {
      return false;
    }

    const userPermSet = new Set(userPerms.map(p => p.toLowerCase()));

    return mustHaveAll
      ? permissions.every(p => userPermSet.has(p.toLowerCase()))
      : permissions.some(p => userPermSet.has(p.toLowerCase()));
  }

  hasAtLeastOneRole(roles: string[]): boolean {
    return this._userRole() ? roles.includes(this._userRole()!) : false;
  }
}
